import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'sbf-rally-game-instructions-modal',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './rally-game-instructions-modal.component.html',
    styleUrls: ['rally-game-instructions-modal.component.scss'],
})
export class RallyGameInstructionsModalComponent implements OnInit {
    constructor(
        private router: Router,
        public activeModal: NgbActiveModal
    ) {}
    ngOnInit() {}
    goHome() {
        this.activeModal.close();
        this.router.navigate(['/']);
    }
    play() {
        this.activeModal.dismiss();
    }
}
